import {MdElderlyWoman, MdWheelchairPickup,MdFamilyRestroom, MdBloodtype, MdHearing} from 'react-icons/md'
import {GiBrain, GiScalpel, GiFootprint, GiKidneys, GiBrokenBone, GiStethoscope} from 'react-icons/gi'
import {BsBandaidFill, BsLungsFill} from 'react-icons/bs'
import {AiFillSkin} from 'react-icons/ai'
import { FaEye, FaTooth} from 'react-icons/fa'

export const Data = [
    {
        id: 1,
        name: 'Geriatricians',
        icon: <MdElderlyWoman/>,
    },
    {
        id: 2,
        name: 'Physiatrists',
        icon: <MdWheelchairPickup/>,
    },
    {
        id: 3,
        name: 'Neurologists',
        icon: <GiBrain/>,
    },
    {
        id: 4,
        name: 'Wound Care Specialists',
        icon: <BsBandaidFill/>,
    },
    {
        id: 5,
        name: 'General Surgeon',
        icon: <GiScalpel/>,
    },
    {
        id: 6,
        name: 'Podiatrist',
        icon: <GiFootprint/>,
    },
    {
        id: 7,
        name: 'Urologist',
        icon: <GiKidneys/>,
    },
    {
        id: 8,
        name: 'Dermatologist',
        icon: <AiFillSkin/>,
    },
    {
        id: 9,
        name: 'Orthopedic Surgeon',
        icon: <GiBrokenBone/>,
    },
    {
        id: 10,
        name: 'Internal Medicine',
        icon: <GiStethoscope/>,
    },
    {
        id: 11,
        name: 'Family Medicine',
        icon: <MdFamilyRestroom/>,
    },
    {
        id: 12,
        name: 'Vascular Surgeon',
        icon: <MdBloodtype/>,
    },
    {
        id: 13,
        name: 'Pulmonologists',
        icon: <BsLungsFill/>,
    },
    {
        id: 14,
        name: 'Audiologist',
        icon: <MdHearing/>,
    },
    {
        id: 15,
        name: 'Optometrist',
        icon: <FaEye/>,
    },
    {
        id: 16,
        name: 'Dentist',
        icon: <FaTooth/>,
    },
]